// Detect iOS Safari
export const isIOSSafari = /iPad|iPhone|iPod/.test(navigator.userAgent);
